var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNews(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 112,
    viewBox: "0 0 113 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.6884 11.6667L44.8704 23.3333H68.4121L56.6884 11.6667ZM18.8334 32.6667V93.3333H94.1667V32.6667H18.8334ZM56.5 0L80.0417 23.3333H94.1667C96.6641 23.3333 99.0593 24.3167 100.825 26.067C102.591 27.8173 103.583 30.1913 103.583 32.6667V93.3333C103.583 95.8087 102.591 98.1827 100.825 99.933C99.0593 101.683 96.6641 102.667 94.1667 102.667H18.8334C16.3359 102.667 13.9407 101.683 12.1748 99.933C10.4088 98.1827 9.41669 95.8087 9.41669 93.3333V32.6667C9.41669 30.1913 10.4088 27.8173 12.1748 26.067C13.9407 24.3167 16.3359 23.3333 18.8334 23.3333H32.9584L56.5 0ZM32.9584 84V65.3333H56.5V84H32.9584ZM65.9167 79.3333V46.6667H84.75V79.3333H65.9167ZM28.25 56V42H51.7917V56H28.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.388fb5dd4613dbfeed1e4ceb750ad8da.svg";
export { ForwardRef as ReactComponent };